
var piBaseTimeseriesURI = "https://jeffpi.fews.jbahosting.com/FewsWebServices/rest/fewspiservice/v1/timeseries"

var appendTimeseriesURIWith = "useDisplayUnits=false&showThresholds=true&omitMissing=false&onlyHeaders=false&showEnsembleMemberIds=true&documentVersion=1.25&documentFormat=PI_JSON&forecastCount=1"


function buildPiTimeseriesUri(piParameters) {
    var locationID = piParameters['locationID'];
    var filterID = piParameters['filterID'];
    var parameterID = piParameters['parameterID'];
    var moduleInstanceID = piParameters['moduleInstanceID'];
    var qualifierID = piParameters['qualifierID'];


    if (piParameters["startDate"] && piParameters["endDate"]) {
        if (piParameters["startTime"] && piParameters["endTime"]) {
            // Specify precise start and end dates
            var startDate = piParameters["startDate"];
            var startTime = piParameters["startTime"];
            var endDate = piParameters["endDate"];
            var endTime = piParameters["endTime"];
        } else {
            console.log("ERROR: startTime and endTime must be provided if specifying a startDate and endDate")
        }
    } else if (piParameters["startDateNumDaysPrevious"] && piParameters["endDateNumDaysInFuture"]) {
        // Dynamically update start and end dates based on current datetime
        var startDate = getDateRelativeToToday(-(parseInt(piParameters["startDateNumDaysPrevious"])));
        var endDate = getDateRelativeToToday(parseInt(piParameters["endDateNumDaysInFuture"]));
        var startTime = getCurrentTime();
        var endTime = getCurrentTime();
    }

    var modifiedTimeseriesURI = piBaseTimeseriesURI.concat("?");

    if (locationID !== undefined & locationID !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`locationIds=${locationID}&`);
    }

    if (filterID !== undefined & filterID !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`filterId=${filterID}&`);
    }

    if (parameterID !== undefined & parameterID !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`parameterIds=${parameterID}&`);
    }

    if (moduleInstanceID !== undefined & moduleInstanceID !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`moduleInstanceIds=${moduleInstanceID}&`);
    }

    if (qualifierID !== undefined & qualifierID !== "" & qualifierID !== null) { //not always supplied
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`qualifierIds=${qualifierID}&`);
    }

    if (startDate !== undefined & startTime !== undefined & startDate !== "" & startTime !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`startTime=${startDate}T${startTime}Z&`);
    }

    if (endDate !== undefined & endTime !== undefined & endDate !== "" & endTime !== "") {
        modifiedTimeseriesURI = modifiedTimeseriesURI.concat(`endTime=${endDate}T${endTime}Z&`);
    }

    modifiedTimeseriesURI = modifiedTimeseriesURI.concat(appendTimeseriesURIWith);

    // Spaces not allowed in a URI
    modifiedTimeseriesURI = modifiedTimeseriesURI.replace(/ /g, '+');

    return modifiedTimeseriesURI
}

function getTodaysDate() {
    var date = new Date();
    var month = date.getMonth() + 1
    var day = date.getDate()
    return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
}

function getCurrentTime() {
    var date = new Date();
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}

function getDateRelativeToToday(numDays) {
    var date = new Date();
    date.setDate(date.getDate() + numDays);
    var month = date.getMonth() + 1
    var day = date.getDate()
    return date.getFullYear() + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
}



function sortObject(object, firstKeys, lastKeys, firstKeysSubstring, lastKeySubstring, keysAreDates = false) {
    // firstKeysSubstring and lastKeySubstring are substrings which sort keys if they are within the key string

    var sorted_object = {}

    if (keysAreDates) {
        var timeIntegerToOriginalKey = {};
        object_keys = [];
        $.each(Object.keys(object), function (idx, key) {
            let timeInteger = new Date(key).getTime();
            object_keys.push(timeInteger);
            timeIntegerToOriginalKey[timeInteger] = key;
        })
        var sorted_keys_time_integers = object_keys.sort();

        var sorted_keys = [];

        $.each(sorted_keys_time_integers, function (idx, int) {
            let originalKey = timeIntegerToOriginalKey[int];
            sorted_keys.push(originalKey);
        })


    } else {
        var object_keys = Object.keys(object);
        var sorted_keys = object_keys.sort();
    }


    if (firstKeys) {
        firstKeys.forEach(function (firstKey) {
            // Put the 'firstKeys' at the start of the object. First keys in the list are placed last.

            for (var i = 0; i < sorted_keys.length; i++) {
                if (sorted_keys[i] === firstKey) {
                    let value = sorted_keys[i];
                    sorted_keys.splice(i, 1);
                    sorted_keys.unshift(value);
                }
            }
        })
    }

    if (lastKeys) {
        lastKeys.forEach(function (lastKey) {
            // Put the 'firstKeys' at the start of the object. First keys in the list are placed last.

            for (var i = 0; i < sorted_keys.length; i++) {

                if (sorted_keys[i] === lastKey) {
                    let value = sorted_keys[i];
                    sorted_keys.splice(i, 1);
                    sorted_keys.push(value);
                }
            }
        })
    }

    //if (firstKeysSubstring) {
    //    firstKeysSubstring.forEach(function (firstKey) {
    //        // Put the 'firstKeys' at the start of the object. First keys in the list are placed last.

    //        for (var i = 0; i < sorted_keys.length; i++) {
    //            if (sorted_keys[i].includes(firstKey)) {
    //                let value = sorted_keys[i];
    //                sorted_keys.splice(i, 1);
    //                sorted_keys.unshift(value);
    //            }
    //        }
    //    })
    //}

    //if (lastKeySubstring) {
    //    lastKeySubstring.forEach(function (lastKey) {
    //        // Put the 'firstKeys' at the start of the object. First keys in the list are placed last.

    //        for (var i = 0; i < sorted_keys.length; i++) {

    //            if (sorted_keys[i].includes(lastKey)) {
    //                let value = sorted_keys[i];
    //                sorted_keys.splice(i, 1);
    //                sorted_keys.push(value);
    //            }
    //        }
    //    })
    //}

    sorted_keys.forEach(function (key) {
        sorted_object[key] = object[key];
    });

    return sorted_object
}


export { buildPiTimeseriesUri, getTodaysDate, getCurrentTime, getDateRelativeToToday, sortObject};